package com.patronat.top.ui.models

import androidx.compose.ui.graphics.painter.Painter

data class NavigationUiItem(
    val id: Any,
    val title: String,
    val icon: Painter,
    val isSelected: Boolean
)